var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._v(" Profile Tags "),_c('TaggerWidget',{attrs:{"tagType":"profile","manage":true}}),_vm._v(" Dataset Tags "),_c('TaggerWidget',{attrs:{"tagType":"dataset","manage":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }